import React from 'react'
import styles from './BlockSwiper.module.css'
import SwipeCheckbox from '../UI/SwipeCheckbox/SwipeCheckbox'

interface Props {
  onChangeHandler: (checked: boolean) => void
  isBlocked: boolean
}

const BlockSwiper: React.FC<Props> = ({ isBlocked, onChangeHandler }) => {
  return (
    <div className={styles.blockContainer}>
      <div className={styles.swipeContainer}>
        <SwipeCheckbox
          id='highload'
          name='highload'
          onChangeHandler={onChangeHandler}
          isBlocked={isBlocked}
        />
      </div>
    </div>
  )
}

export default BlockSwiper
